import { useCurrentProjectId } from '@adsk/alloy-provider';
import { useMemo } from 'react';
import { createSDK } from '../sdk';

export const useSDK = () => {
  const projectId = useCurrentProjectId() || '';
  return useMemo(() => createSDK({ projectId }), [projectId]);
};
